import React from "react";
import { observer } from "mobx-react-lite";
import { useApp } from "../context";

import {
  createTheme,
  ThemeProvider as MaterialThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "#F28F3B",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ff8a53ff",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: "inherit",
  },
});

theme = responsiveFontSizes(theme);

export const ThemeProvider = observer(function ThemeProvider({ children }) {
  const app = useApp();

  return <MaterialThemeProvider theme={theme} children={children} />;
});
